import { ProductTranslation } from '../content/ProductInterfaces';

export const localizeString = (value: ProductTranslation, language: string): string => {
  if (!value) {
    return '';
  }
  return value[language];
};

export const addColon = (key: string): string => {
  return key && key.endsWith(':') ? key : `${key}:`;
};

export const cutLongName = (key: string): string => {
  if (!key) {
    return '';
  }
  const parts: string[] = key.split(' ');
  return parts
    .filter((p) => p.length < 30)
    .slice(0, 10)
    .join(' ');
};

export const removeInvalidSymbolsForId = (eanCode: string): string => {
  return eanCode.replace(/[^a-zA-Z0-9]/g, '');
};
